import { FC } from 'react';
import useContentsList from '../../hooks/useContentsList';
import useCourse from '../../hooks/useCourse';
import useSelectTraining from '../../hooks/useSelectTraining';
import { CourseInfo } from '../../types/apis/contentsListApi';
import LessonContent from '../Organisms/LessonContent';
import LessonContinuation from '../Organisms/LessonContinuation';
import AutoLogoffModal from '../Templates/AutoLogoffModal';
import ElmerModalAlert from '../Templates/ElmerModalAlert';
import PageLoadingLayer from '../Templates/PageLoadingLayer';
import styles from './Lesson.module.scss';

const SelectTraining: FC = () => {
  const useCourseValue = useCourse();
  const useContentsListValue = useContentsList();
  const useSelectTrainingValue = useSelectTraining();

  return (
    <>
      {useContentsListValue.isCallingApi && <PageLoadingLayer />}
      {useContentsListValue.lessonAlert.type !== null &&
        (useContentsListValue.lessonAlert.type === 'INFO_LOGOFF' ? (
          <AutoLogoffModal
            isModalOpen={useContentsListValue.lessonAlert.type !== null}
            closeModal={useContentsListValue.onClickCloseModal}
          />
        ) : (
          <ElmerModalAlert
            isModalOpen={useContentsListValue.lessonAlert.type !== null}
            alertTitle={useContentsListValue.lessonAlert.alertTitle}
            alertText={useContentsListValue.lessonAlert.alertText}
            alertButtons={useContentsListValue.lessonAlert.alertButtons}
          />
        ))}

      <div className={styles.lesson}>
        <h1 className={styles['h1-title']}>{useCourseValue.courseName}</h1>
        <ul className={styles['topic-list']}>
          {useContentsListValue.contents.map((info: CourseInfo) => (
            <LessonContent
              key={info.number}
              info={info}
              topicNumber={useSelectTrainingValue.topicNumber}
              onClickTopicButton={useSelectTrainingValue.onClickTopicButton}
              onClickTrainingButton={
                useSelectTrainingValue.onClickTrainingButton
              }
              contents={useContentsListValue.contents}
            />
          ))}
        </ul>
      </div>

      {useContentsListValue.resume && (
        <LessonContinuation
          number={useContentsListValue.resume.number}
          description={useContentsListValue.resume.description}
          trainingId={useContentsListValue.resume.trainingId}
          onClickContinueButton={useSelectTrainingValue.onClickContinueButton}
          contents={useContentsListValue.contents}
        />
      )}
    </>
  );
};

export default SelectTraining;
